import React from 'react';
import { Link } from 'react-router-dom';
import './ScopeChips.css';

export interface ScopeChipItem {
  key: string;
  label: string;
  to: string;
  active?: boolean;
}

/** The country/city selector row on all three board pages — plain navigation chips, not a form
 * control, so each option is a real link (shareable URL, works without JS). */
const ScopeChips: React.FC<{ items: ScopeChipItem[]; ariaLabel: string }> = ({ items, ariaLabel }) => {
  if (items.length === 0) {
    return null;
  }
  return (
    <nav className="sc-chips" aria-label={ariaLabel}>
      {items.map((item) => (
        <Link key={item.key} to={item.to} className={`sc-chip ${item.active ? 'sc-chip-active' : ''}`}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default ScopeChips;
